export const messages = {
    "wre-dashboard.nav-menu.item.shared": "Delning",
    "wre-dashboard.nav-menu.item.backups": "Säkerhetskopior",
    "wre-dashboard.nav-menu.item.machines": "Datorer",
    "wre-dashboard.nav-menu.item.account": "Konto",
    "wre-dashboard.search.input.hint": "Sök",
    "wre-dashboard.search.label.breadcrumb": "Sökresultat",
    "wre-dashboard.search.message.empty": "Inga poster matchar dina sökkriterier",
    "wre-dashboard.side-bar.selected.title:plural": "{count} valda artiklar | {count} vald artikel | {count} valda artiklar",
    "wre-dashboard.side-bar.backup-type.disk": "Disk",
    "wre-dashboard.side-bar.backup-type.file": "Fil",
    "wre-dashboard.side-bar.backup-type.notarized": "Attesterade filer och mappar",
    "wre-dashboard.side-bar.backup-type.exchange": "Program - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "Program - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "Program - systemtillstånd",
    "wre-dashboard.side-bar.backup-type.application": "Program",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} kvar",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} används",
    "wre-dashboard.space-indicator.label.unlimited": "Obegränsad",
    "wre-dashboard.backups-table.column.name": "Namn",
    "wre-dashboard.backups-table.column.size": "Storlek",
    "wre-dashboard.backups-table.column.version": "Senaste säkerhetskopiering",
    "wre-dashboard.backups-table.message.no-backups": "Det finns inga säkerhetskopior i molnet ännu",
    "wre-dashboard.backups-sidebar.label.size": "Storlek",
    "wre-dashboard.backups-sidebar.label.type": "Typ",
    "wre-dashboard.backups-sidebar.label.version": "Senaste version",
    "wre-dashboard.backups-sidebar.label.created": "Skapad",
    "wre-dashboard.backups-sidebar.label.machine": "Dator",
    "wre-dashboard.backups-sidebar.label.owner": "Ägare",
    "wre-dashboard.content-table.column.name": "Namn",
    "wre-dashboard.content-table.column.versions": "Versioner",
    "wre-dashboard.content-table.column.volumes": "Volymer",
    "wre-dashboard.content-table.column.path": "Sökväg",
    "wre-dashboard.content-table.column.size": "Storlek",
    "wre-dashboard.content-table.column.version": "Senaste version",
    "wre-dashboard.content-table.action.versions": "Versioner",
    "wre-dashboard.content-table.action.restore": "Hämta",
    "wre-dashboard.content-table.action.share": "Dela länk",
    "wre-dashboard.content-table.label.size": "Storlek",
    "wre-dashboard.content-table.label.created": "Skapad",
    "wre-dashboard.content-table.label.modified": "Modifierad",
    "wre-dashboard.content-table.message.empty-folder": "Mappen är tom",
    "wre-dashboard.password-dialog-box.title.backup": "Krypterade säkerhetskopior",
    "wre-dashboard.password-dialog-box.title.archive": "Krypterat arkiv",
    "wre-dashboard.password-dialog-box.message.backup": "Ange lösenordet för att få åtkomst till säkerhetskopia {displayName}",
    "wre-dashboard.password-dialog-box.message.archive": "Ange lösenordet för att få åtkomst till arkiv {displayName}",
    "wre-dashboard.password-dialog-box.hint.password": "Lösenord",
    "wre-dashboard.password-dialog-box.message.invalid-password": "Lösenordet är felaktigt",
    "wre-dashboard.form.button.open": "Öppna",
    "wre-dashboard.form.button.close": "Stäng",
    "wre-dashboard.form.button.cancel": "Avbryt",
    "wre-dashboard.form.button.delete": "Radera",
    "wre-dashboard.shared-content-table.column.name": "Namn",
    "wre-dashboard.shared-content-table.column.location": "Plats",
    "wre-dashboard.shared-content-table.column.source": "Källa",
    "wre-dashboard.shared-content-table.column.days": "Dagar",
    "wre-dashboard.shared-content-table.column.downloads": "Hämtningar",
    "wre-dashboard.shared-content-table.column.shared": "Delad på",
    "wre-dashboard.shared-content-table.label.shared": "Delad på",
    "wre-dashboard.shared-content-table.label.backup": "Källa",
    "wre-dashboard.shared-content-table.action.share": "Dela länk",
    "wre-dashboard.shared-content-table.action.settings": "Länkinställningar",
    "wre-dashboard.shared-content-table.action.delete": "Radera länk",
    "wre-dashboard.shared-content-table.action.delete-selected": "Radera länkar",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} ledigt av {totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: Obegränsat utrymme",
    "wre-dashboard.account-page.button.sign-out": "Logga ut",
    "wre-dashboard.account-page.button.manage-subscription": "Hantera licens",
    "wre-dashboard.account-page.message.subscription.active": "Din licens för {brandName} utrymme löper ut den",
    "wre-dashboard.account-page.message.subscription.trial": "{brandName} prov är aktiv tills",
    "wre-dashboard.account-page.message.subscription.expired": "Din licens för {brandName} utrymme löpte ut den",
    "wre-dashboard.account-page.message.worm-status.storage-full": "Ditt lagringsutrymme {brandName} är fullt. Du kan inte säkerhetskopiera eller arkivera data till molnet.",
    "wre-dashboard.account-page.message.worm-status.less-than": "Färre än {percent} procent är ledigt. Snart kan du inte längre använda {brandName}.",
    "wre-dashboard.versions-dialog-box.title": "Versioner av {fileName}",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "Kopiera länk",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "Länkinställningar",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "Den som har länken kan se den senaste versionen av data",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "Delad på {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "Länk kopierad",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "Fel vid länkkopiering",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "Radera länk",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "Denna länk kommer inte längre att fungera för de som har den",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "Radera länkar",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "Dessa länkar kommer att sluta att fungera för de som har dem",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "Länkinställningar",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "Radera länk",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "Klar",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "Lösenord",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "Återställ lösenord",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "Lösenordsskydd",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "Skydda denna länk med ett lösenord",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "Utgångsdatum",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "Hämtningsgräns",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "Inaktivera denna länk om {splitMarker} dagar | Inaktivera denna länk om {splitMarker} dag | Inaktivera denna länk om {splitMarker} dagar",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "Inaktivera denna länk efter {splitMarker} hämtningar | Inaktivera denna länk efter {splitMarker} hämtning | Inaktivera denna länk efter {splitMarker} hämtningar",
    "wre-dashboard.sub-accounts-dialog-box.title": "Konton",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "Sök",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "Inga poster matchar dina sökkriterier",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "Namn",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "Användning",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "Senaste säkerhetskopiering",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "Löper ut",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} ledigt av {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "Volymprenumeration",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "Har löpt ut",
    "wre-dashboard.machines-table.column.name": "Namn",
    "wre-dashboard.machines-table.column.size": "Storlek",
    "wre-dashboard.machines-table.message.no-machines": "Det finns inga datorer i molnet ännu"
};
